import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CompaniesService } from "../companies/companies.service";
import { ApiService } from "../shared";
import { ProjectsService } from "../projects/projects.service";
import { ConfigService } from "../config.service";
import { ProgramsService } from "../programs/programs.service";

@Injectable()
export class NotificationsService {
  static currentNotification: any;
  private serviceUrl = ConfigService.serviceUrl;

  constructor(
    private http: Http,
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService,
    private programService: ProgramsService
  ) {}

  getNotifications(options): Observable<any> {
    const { skip, limit } = this.generateOptions(options);

    return this.http
      .get(`${this.serviceUrl}/notifications?skip=${skip}&limit=${limit}`)
      .map((res) => {
        return this.extractData(res, true);
      })
      .catch(this.handleError);
  }

  generateOptions(options) {
    const { page, limit } = options;
    return {
      skip: page * limit,
      limit
    };
  }

  getProjectNames(notifications: any[]) {
    this.projectsService.getProjectList().subscribe((projectList) => {
      notifications.map((noti) => {
        noti.projectNames = [];
        if (!noti.projects || noti.projects.length < 1) {
          noti.projectNames = ["<any>"];
        } else {
          noti.projects.map((id) => {
            let projects = projectList.filter((it) => {
              return it.id === id;
            });
            if (projects.length > 0) {
              noti.projectNames.push(projects[0].name);
            }
          });
        }
      });
    });
  }

  getEmployerNames(notifications: any[]) {
    this.companiesService.getEmployers().subscribe((employerList) => {
      notifications.map((noti) => {
        noti.employerNames = [];
        if (!noti.employer || noti.employer.length < 1) {
          noti.employerNames = ["<any>"];
        } else {
          noti.employer.map((id) => {
            let employers = employerList.filter((it) => {
              return it.id === id;
            });
            if (employers.length > 0) {
              noti.employerNames.push(employers[0].name);
            }
          });
        }
      });
    });
  }

  getLanguages(): any[] {
    return ConfigService.languages;
  }

  getCountries(): any[] {
    return ConfigService.countryList;
  }

  getProjects() {
    return this.projectsService.getProjectList();
  }

  getEmployers() {
    return this.companiesService.getEmployers();
  }

  getPrograms() {
    return this.programService.getPrograms();
  }

  getCountryNames(ids: string[]): string[] {
    if (ids) {
      let names = ApiService.getCountryNames(ids);
      if (names.length > 0) {
        return names;
      }
    }
    return ["<any>"];
  }

  getLanguageNames(ids: string[]): string[] {
    if (ids) {
      let names = ApiService.getLanguageNames(ids);
      if (names.length > 0) {
        return names;
      }
    }
    return ["<any>"];
  }

  sendNotification(noti: any) {
    let notification = Object.assign({}, noti);
    if (notification.language === "") {
      delete notification.language;
    }
    if (notification.projects && notification.projects[0] === "") {
      delete notification.projects;
    }
    if (notification.nationality && notification.nationality[0] === "") {
      delete notification.nationality;
    }
    if (notification.country && notification.country[0] === "") {
      delete notification.country;
    }
    if (notification.employer && notification.employer[0] === "") {
      delete notification.employer;
    }
    return this.http.post(`${this.serviceUrl}/notifications`, notification).map(
      (resp) => {
        return this.extractData(resp, null);
      },
      (error) => {
        return this.handleError(error);
      }
    );
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  }

  private extractData(res: Response, getNames: boolean) {
    let body = res.json();
    if (getNames) {
      this.getProjectNames(body);
      this.getEmployerNames(body);
    }
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/notifications.service.ts